import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GasDatatableComponent } from './gas-datatable.component';

const COMPONENTS = [
  GasDatatableComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
  ],
})
export class GasDatatableModule { }
